import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactTable from "react-table";
import { Flag, Icon, Dropdown, Button } from 'semantic-ui-react';
import { enums } from '../../helpers';
import { DateRange } from '../../components';
import client from '../../client';
import moment from 'moment';
import { ReviewRefundRequestModal } from '../../components';

import './RefundExplorer.css';

export default class RefundExplorer extends Component {
  static propTypes = {
    refunds: PropTypes.array,
    operators: PropTypes.array,
    pages: PropTypes.num,
    loading: PropTypes.bool,
    getOperatorData: PropTypes.func,
    getRefunds: PropTypes.func
  }

  constructor(props) {
    super(props);
    this.props.getOperatorData();
    this.state = {
      startDate: null,
      endDate: null,
      showModal: false,
      exporting: false,
      entity: '',
      country: '',
      operator: '',
      method: '',
      status: ''
    }
  }

  onDatesChange = ({ startDate, endDate }) => {
    this.setState({ startDate, endDate });
    if(startDate && endDate)
      this.props.getRefunds({
        ...this.state,
        ...(startDate && endDate ? { startDate, endDate } : {})
      });
  }

  downloadDataAsCSV = () => {
    this.setState({ exporting: true })
    client
      .post('/refunds/export', this.state)
      .then(({ data }) => {
        var element = document.createElement("a");
        var file = new Blob([data], { type: "text/csv" });
        element.href = URL.createObjectURL(file);
        element.download = `export.csv`;
        element.click();
        this.setState({ exporting: false })
      })
  }

  onFilterChange = (field) => (value, callback) => this.setState({[field]: value}, () => callback(value))

  toggleModal = (caseId) => caseId ? this.setState({ showModal: caseId }) : this.setState({ showModal: false })

  closeModal = () => this.setState({ showModal: false })

  render() {
    const { startDate, endDate } = this.state;
    const countries = this.props.operators ? this.props.operators.reduce((countriesCurr, operator) => ({
      ...countriesCurr,
      [operator.countryId]: operator.countryName
    }), {}) : {};

    const countryIdToISO = this.props.operators ? this.props.operators.reduce((countriesCurr, operator) => ({
      ...countriesCurr,
      [operator.countryId]: operator.countryISO
    }), {}) : {};

    const ocToName = this.props.operators ? this.props.operators.reduce((operatorsCurr, operator) => ({
      ...operatorsCurr,
      [operator.oc]: operator.operatorName
    }), {}) :{};

    const operators = this.props.operators ? this.props.operators.reduce((operatorsCurr, operator) => ({
      ...operatorsCurr,
      [operator.oc]: operator.operatorName
    }), {}) :{};

    const countriesToEntities = this.props.operators ? this.props.operators.reduce((acc, curr) => ({
      ...acc,
      [curr.countryISO]: Array.from(new Set([
        ...(acc[curr.countryISO] ? acc[curr.countryISO] : []),
        ...curr.services.map(service => service.entity)
      ]))
    }), {}) : {};


    const countryOptions = Object
      .keys(countries)
      .map(countryId => ({ key: countryId, value: countryId, text: countries[countryId] }))
      .filter(country => !this.state.entity || countriesToEntities[countryIdToISO[country.key]].includes(this.state.entity))
      .filter(country => !this.state.operator || this.props.operators.find(operator => operator.countryISO === countryIdToISO[country.key] && operator.oc === parseInt(this.state.operator, 10)))
      .filter(country => !this.state.method || countriesToEntities[countryIdToISO[country.key]].find(entity => enums.entityToRefundMethod[entity] ? enums.entityToRefundMethod[entity][this.state.method] : false))

    const operatorOptions = Object
      .keys(operators)
      .filter(operator => !this.state.entity || countriesToEntities[this.props.operators.find(operatorObj => operatorObj.oc === parseInt(operator, 10)).countryISO].includes(this.state.entity))
      .filter(operator => !this.state.country || this.props.operators.find(operatorObj => operatorObj.oc === parseInt(operator, 10) && operatorObj.countryId === parseInt(this.state.country, 10)))
      .filter(operator => !this.state.method || countriesToEntities[this.props.operators.find(operatorObj => operatorObj.oc === parseInt(operator, 10)).countryISO].find(entity => enums.entityToRefundMethod[entity] ? enums.entityToRefundMethod[entity][this.state.method] : false))
      .map(operator => ({ key: operator, value: operator, text: ocToName[operator] }));

    const refundMethods = Object
      .keys(enums.refundMethods)
      .filter(method => !this.state.entity || enums.entityToRefundMethod[this.state.entity][method])
      .filter(method => !this.state.operator || countriesToEntities[this.props.operators.find(operator => operator.oc === parseInt(this.state.operator, 10)).countryISO].find(entity => enums.entityToRefundMethod[entity] ? enums.entityToRefundMethod[entity][method] : false))
      .filter(method => !this.state.country || countriesToEntities[countryIdToISO[this.state.country]].find(entity => enums.entityToRefundMethod[entity] ? enums.entityToRefundMethod[entity][method] : false))
      .map(method => ({ key: method, value: method, text: enums.refundMethods[method] }));

    const currencyOptions = Object
      .keys(enums.currencies)
      .map(currency => ({ key: currency, value: currency, text: enums.currencies[currency] }));

    const entityOptions = Object
      .keys(enums.entityToRefundMethod)
      .filter(entity => !this.state.method || (enums.entityToRefundMethod[entity] ? enums.entityToRefundMethod[entity][this.state.method] : false))
      .filter(entity => !this.state.country || countriesToEntities[countryIdToISO[this.state.country]].includes(entity))
      .filter(entity => !this.state.operator || countriesToEntities[this.props.operators.find(operator => operator.oc === parseInt(this.state.operator, 10)).countryISO].includes(entity))
      .map(entity => ({ key: entity, value: entity, text: entity }));

    const statusOptions = ['REQUESTED', 'APPROVED', 'RETURNED', 'COMPLETED', 'REJECTED'].map(value => ({ key: value, value, text: value}))

    return (
      <div className="RefundExplorer main-content">
          <div className="RefundFilters">
              <div className="main-title">
                  Explore Refunds
                  <span className="main-title__length"> {this.props.total}</span>
              </div>
              <div className="main-toolbar">
                  <div className="main-toolbar_item">
                      <Button onClick={this.downloadDataAsCSV} className="DownloadButton btn btn_blue" loading={this.state.exporting}>Export</Button>
                  </div>
                  <div className="main-toolbar_item">
                      <DateRange
                          startDate={startDate}
                          endDate={endDate}
                          onChange={this.onDatesChange}
                          className="DateRange"
                      />
                  </div>
              </div>
          </div>
        <ReactTable
          className="RefundExplorerTable -striped"
          data={this.props.refunds ? this.props.refunds.map(refund => ({
            ...refund,
            refundMethod: enums.refundMethods[refund.refundMethod],
            createdAt: moment(refund.createdAt).format('YYYY-MM-DD HH:mm'),
            updatedAt: moment(refund.updatedAt).format('YYYY-MM-DD HH:mm'),
            country: this.props.operators && this.props.operators.length ? <span><Flag name={this.props.operators.find(operator => operator.countryId === refund.countryId).countryISO.toLowerCase()} /> {this.props.operators.find(operator => operator.countryId === refund.countryId).countryISO}</span> : null,
            operator: this.props.operators && this.props.operators.length ? this.props.operators.find(operator => operator.oc === refund.oc).operatorName : null,
            service: this.props.operators && this.props.operators.length ? this.props.operators.find(operator => operator.oc === refund.oc).services.find(service => refund.srvcId.toString() === service.id).name : null,
            currency: enums.currencies[refund.amount.currency],
            totalAmount: (refund.amount.value + refund.amount.processingFee).toFixed(2)
          })) : []}
          loading={this.props.loading}
          columns={[
            {
              Header: 'Case ID',
              accessor: '_id',
              Filter: () => <span className="default text">Case ID</span>,
              filterable: true
            },
            {
              Header: () => <span>Created</span>,
              width: 145,
              accessor: 'createdAt',
              Filter: () => <span className="default text">Created</span>,
              filterable: true
            },
            {
              Header: 'Entity',
              accessor: 'entity',
              filterable: true,
              Filter: ({ filter, onChange }) => <Dropdown
                compact
                placeholder="Entity"
                fluid
                search
                options={[{key: '', value: '', text: 'Select All'}, ...entityOptions]}
                onChange={(e, {value}) => this.onFilterChange('entity')(value, onChange)}
                value={ filter ? filter.value : '' }
              />
            },
            {
              Header: () => <span>Status</span>,
              width: 115,
              accessor: 'status',
              filterable: true,
              Filter: ({ filter, onChange }) => <Dropdown
                compact
                placeholder="Status"
                fluid
                search
                options={[{key: '', value: '', text: 'Select All'}, ...statusOptions]}
                onChange={(e, {value}) => this.onFilterChange('status')(value, onChange)}
                value={ filter ? filter.value : '' }
              />
            },
            {
              Header: 'Method',
              accessor: 'refundMethod',
              filterable: true,
              Filter: ({ filter, onChange }) => <Dropdown
                compact
                placeholder="Method"
                fluid
                search
                options={[{key: '', value: '', text: 'Select All'}, ...refundMethods]}
                onChange={(e, {value}) => this.onFilterChange('method')(value, onChange)}
                value={ filter ? filter.value : '' }
              />
            },
            {
              Header: 'Updated At',
              accessor: 'updatedAt',
              Filter: () => <span className="default text">Updated At</span>,
              filterable: true
            },
            {
              Header: () => <span>Country</span>,
              width: 75,
              accessor: 'country',
              filterable: true,
              Filter: ({ filter, onChange }) => <Dropdown
                compact
                placeholder="Country"
                fluid
                search
                options={[{key: '', value: '', text: 'Select All'}, ...countryOptions]}
                onChange={(e, {value}) => this.onFilterChange('country')(value, onChange)}
                value={ filter ? filter.value : '' }
              />
            },
            {
              Header: 'Operator',
              accessor: 'operator',
              filterable: true,
              Filter: ({ filter, onChange }) => <Dropdown
                compact
                placeholder="Operator"
                fluid
                search
                options={[{key: '', value: '', text: 'Select All'}, ...operatorOptions]}
                onChange={(e, {value}) => this.onFilterChange('operator')(value, onChange)}
                value={ filter ? filter.value : '' }
              />
            },
            {
              Header: 'Service',
              accessor: 'service',
              Filter: () => <span className="default text">Service</span>,
              filterable: true
            },
            {
              Header: 'Amount',
              accessor: 'totalAmount',
              Filter: () => <span className="default text">Amount</span>,
              filterable: true
            },
            {
              Header: () => <span>Refunded</span>,
              width: 70,
              accessor: 'totalRefunded',
              Filter: () => <span className="default text">Refunded</span>,
              filterable: true
            },
            {
              Header: () => <span>Currency</span>,
              width: 65,
              accessor: 'currency',
              filterable: true,
              Filter: ({ filter, onChange }) => <Dropdown
                compact
                placeholder="Currency"
                fluid
                search
                options={[{key: '', value: '', text: 'Select All'}, ...currencyOptions]}
                onChange={(e, {value}) => this.onFilterChange('currency')(value, onChange)}
                value={ filter ? filter.value : '' }
              />
            }
          ]}
          defaultPageSize={10}
          pageSizeOptions= {[5,10,20,50,100,200,300]}
          pages={this.props.pages}
          manual
          sortable={false}
          onFetchData={(state, instance) => {
            const { page, pageSize, sorted, filtered } = state;
            this.setState({ page, limit: pageSize, sorted, filters: filtered, startDate, endDate })
            console.log(filtered);
            return this.props.getRefunds({
              page,
              limit: pageSize,
              sorted,
              filters: filtered,
              ...(startDate && endDate ? {startDate, endDate} : {})
            });
          }}
          getLoadingProps={() => ({
            loadingText:
                <div className="loading-widget loading-widget_table">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                        <g fill="none" fill-rule="evenodd">
                            <path className="loading-widget__draw-animation" stroke="#4061AD" stroke-width="1" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="10" stroke-dasharray="300" stroke-dashoffset="300" fill="none" d="M19.783 5.792V.793c0-.581-.476-.82-1.057-.555L6.137 6.188c-.582.265-1.058.952-1.058 1.534v20.972c0 .582.476.82 1.058.556l13.62-6.427-4.655 2.222V13.488l-2.565 1.269v-5.58l7.246-3.385z"/>
                            <path className="loading-widget__draw-animation" stroke="#14AFE4" stroke-width="1" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="10" stroke-dasharray="300" stroke-dashoffset="300" fill="none" d="M26.21 2.75L18.435 6.4l1.322-.635V22.77l-4.655 2.195V13.488l-2.538 1.269v16.45c0 .581.476.82 1.057.555l12.589-5.924c.582-.264 1.058-.952 1.058-1.534V3.332c0-.608-.476-.846-1.058-.582z"/>
                        </g>
                    </svg>
                </div>
            })}
          getPaginationProps={() => ({
            nextText: <Icon name="icon1 icon1_angle-right"  />,
            previousText: <Icon name="icon1 icon1_angle-left icon" />
          })}
          getTrProps={(state, rowInfo) => ({
            onClick: (e) => this.toggleModal(rowInfo.original._id),
            style: {
              cursor: rowInfo ? 'pointer' : null
            }
          })}
        />
        <ReviewRefundRequestModal
          initialValues={this.props.refunds.find(refund => refund._id === this.state.showModal)}
          open={this.state.showModal}
          close={this.closeModal}
          refundCount={this.props.refundCount}
          getRefundsCount={this.props.getRefundsCount}
          updateStatus={this.props.updateStatus}
          addComment={this.props.addComment}
          operators={this.props.operators}
          uploadFiles={this.props.uploadFiles}
          type="manager"
          uploading={this.props.uploading}
          getTransactions={this.props.getTransactions}
          transactions={this.props.transactions}
          loadingTransactions={this.props.loadingTransactions}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RefundExplorerRouteComponent/RefundExplorer.js